module.exports = __webpack_public_path__ + "static/media/home-text-mobile.b48ffdc4.png";